export default "__VITE_ASSET__DKH1tKp$__"